<template>
    <v-container fluid="">
        <v-layout row="" wrap="" >

            <v-flex class="elevation-4 v-card theme--light mr-4"  v-show="ucus1" xs12 sm4 md2>
                <v-layout justify-space-between column>
                    <v-card    flat="">


                <v-img src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" height="100px">
                 <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-content-center="">
                                        <span class="display-1 font-weight-light white--text mb-2">1. Uçuş</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                </v-img>
                        <v-card-actions>
                            <v-layout row="" wrap>
                                <tarihcomp :etiket="'Uçuş Tarihi'" v-bind:value="val.Ucus1.UcusTarihi" v-model="val.Ucus1.UcusTarihi"></tarihcomp>
                                <v-text-field hide-details=""  v-model="val.Ucus1.UcusSaat" label="Uçuş Saat"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus1.UcusHY" label="Hava Yolu Kodu"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus1.UcusNo" label="Uçuş No"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus1.Parkur" label="Havalimanı"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus1.UcusClass" label="Class"></v-text-field>

                                <tarihcomp :etiket="'Varış Tarihi'" v-bind:value="val.Ucus1.VarisTarihi" v-model="val.Ucus1.VarisTarihi"></tarihcomp>

                                <v-text-field hide-details=""  v-model="val.Ucus1.VarisSaat" label="Varış Saati"></v-text-field>

                                <parainput :etiket="'FareBases'" v-model="val.Ucus1.FareBases"></parainput>

                                <v-checkbox label="Aktarma" v-model="val.Ucus1.Aktarma" hide-details=""></v-checkbox>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-layout>
            </v-flex>

            <v-flex class="elevation-4 v-card theme--light mr-4" v-show="ucus2" xs12 sm4 md2>
                <v-layout justify-space-between column>
                    <v-card    flat="">
                        <v-img src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" height="100px">

                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-content-center="">
                                        <span class="display-1 font-weight-light white--text mb-2">2. Uçuş</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>

                        <v-card-actions>
                            <v-layout row="" wrap>
                                <tarihcomp :etiket="'Uçuş Tarihi'" v-bind:value="val.Ucus2.UcusTarihi" v-model="val.Ucus2.UcusTarihi"></tarihcomp>

                                <v-text-field hide-details=""  v-model="val.Ucus2.UcusSaat" label="Uçuş Saat"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus2.UcusHY" label="Hava Yolu Kodu"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus2.UcusNo" label="Uçuş No"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus2.Parkur" label="Havalimanı"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus2.UcusClass" label="Class"></v-text-field>

                                <tarihcomp :etiket="'Varış Tarihi'" v-bind:value="val.Ucus2.VarisTarihi" v-model="val.Ucus2.VarisTarihi"></tarihcomp>

                                <v-text-field hide-details=""  v-model="val.Ucus2.VarisSaat" label="Varış Saati"></v-text-field>

                                <parainput :etiket="'FareBases'" v-model="val.Ucus2.FareBases"></parainput>

                                <v-checkbox label="Aktarma" v-model="val.Ucus2.Aktarma" hide-details=""></v-checkbox>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-layout>
            </v-flex>

            <v-flex class="elevation-4 v-card theme--light mr-4" v-show="ucus3" xs12 sm4 md2>
                <v-layout justify-space-between column>
                    <v-card    flat="">
                        <v-img src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" height="100px">

                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-content-center="">
                                        <span class="display-1 font-weight-light white--text mb-2">3. Uçuş</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>

                        <v-card-actions>
                            <v-layout row="" wrap>
                                <tarihcomp :etiket="'Uçuş Tarihi'" v-bind:value="val.Ucus3.UcusTarihi" v-model="val.Ucus3.UcusTarihi"></tarihcomp>

                                <v-text-field hide-details="" m v-model="val.Ucus3.UcusSaat" label="Uçuş Saat"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus3.UcusHY" label="Hava Yolu Kodu"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus3.UcusNo" label="Uçuş No"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus3.Parkur" label="Havalimanı"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus3.UcusClass" label="Class"></v-text-field>

                                <tarihcomp :etiket="'Varış Tarihi'" v-bind:value="val.Ucus3.VarisTarihi" v-model="val.Ucus3.VarisTarihi"></tarihcomp>

                                <v-text-field hide-details="" v-model="val.Ucus3.VarisSaat" label="Varış Saati"></v-text-field>

                                <parainput :etiket="'FareBases'" v-model="val.Ucus3.FareBases"></parainput>

                                <v-checkbox label="Aktarma" v-model="val.Ucus3.Aktarma" hide-details=""></v-checkbox>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-layout>
            </v-flex>

              <v-flex class="elevation-4 v-card theme--light mr-4" v-show="ucus4" xs12 sm4 md2>
                <v-layout justify-space-between column>
                    <v-card    flat="">
                        <v-img src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" height="100px">
                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-content-center="">
                                        <span class="display-1 font-weight-light white--text mb-2">4. Uçuş</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>

                        <v-card-actions>
                            <v-layout row="" wrap>
                                <tarihcomp :etiket="'Uçuş Tarihi'" v-bind:value="val.Ucus4.UcusTarihi" v-model="val.Ucus4.UcusTarihi"></tarihcomp>

                                <v-text-field hide-details=""  v-model="val.Ucus4.UcusSaat" label="Uçuş Saat"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus4.UcusHY" label="Hava Yolu Kodu"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus4.UcusNo" label="Uçuş No"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus4.Parkur" label="Havalimanı"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus4.UcusClass" label="Class"></v-text-field>

                                <tarihcomp :etiket="'Varış Tarihi'" v-bind:value="val.Ucus4.VarisTarihi" v-model="val.Ucus4.VarisTarihi"></tarihcomp>

                                <v-text-field hide-details=""  v-model="val.Ucus4.VarisSaat" label="Varış Saati"></v-text-field>

                                <parainput :etiket="'FareBases'" v-model="val.Ucus4.FareBases"></parainput>

                                <v-checkbox label="Aktarma" v-model="val.Ucus4.Aktarma" hide-details=""></v-checkbox>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-layout>
            </v-flex>

              <v-flex class="elevation-4 v-card theme--light mr-4" v-show="ucus5" xs12 sm4 md2>
                <v-layout justify-space-between column>
                    <v-card    flat="">
                        <v-img src="https://cdn.vuetifyjs.com/images/cards/plane.jpg" height="100px">

                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-content-center="">
                                        <span class="display-1 font-weight white--text mb-2"> 5. Uçuş </span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>

                        <v-card-actions>
                            <v-layout row="" wrap>
                                <tarihcomp :etiket="'Uçuş Tarihi'" v-bind:value="val.Ucus5.UcusTarihi" v-model="val.Ucus5.UcusTarihi"></tarihcomp>

                                <v-text-field hide-details=""  v-model="val.Ucus5.UcusSaat" label="Uçuş Saat"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus5.UcusHY" label="Hava Yolu Kodu"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus5.UcusNo" label="Uçuş No"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus5.Parkur" label="Havalimanı"></v-text-field>

                                <v-text-field hide-details="" v-model="val.Ucus5.UcusClass" label="Class"></v-text-field>

                                <tarihcomp :etiket="'Varış Tarihi'" v-bind:value="val.Ucus5.VarisTarihi" v-model="val.Ucus5.VarisTarihi"></tarihcomp>

                                <v-text-field hide-details=""  v-model="val.Ucus5.VarisSaat" label="Varış Saati"></v-text-field>

                                <parainput :etiket="'FareBases'" v-model="val.Ucus5.FareBases"></parainput>

                                <v-checkbox label="Aktarma" v-model="val.Ucus5.Aktarma" hide-details=""></v-checkbox>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-layout>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
    import tarihcomp from '../../customcomp/tarihim'
    import parainput from '@/components/app/customcomp/parainput.vue'

    export default {
        props: ["value", "ucus1", "ucus2", "ucus3", "ucus4", "ucus5", ],
        components: {
            tarihcomp,
            parainput

        },
        computed: {
            val: {
                get: function () {

                    return this.value;
                },
                set: function (newValue) {
                    this.$emit('input', newValue)
                },
            },
        },


        data() {
            return {

            }
        },

        watch: {

        },
        methods: {


        },


    }
</script>